import React, {useEffect} from "react";
import {cameraState} from "../../state";
import {Vector3} from "three";
import {useSnapshot} from "valtio";
import {useFrame} from "@react-three/fiber";
import { degToRad } from "three/src/math/MathUtils.js";

const CamaraController = ({orbit}) => {
  
  const {currentCamPos, camaraPositions} = useSnapshot(cameraState);
  
  let currCamPos;
  let animInAction = false;

  let newPos = new Vector3(0, 1, 1);
  let newTarget = new Vector3(0, 0, 0);

  let defaultPos = new Vector3(0.5388683829940089, 1.225962765245144, 1.6760494383450844);
  let defaultTarget = new Vector3(0.5453857141546905, 0.9275014734592446, -0.2211245745420456);
  
  let t = 0;
  let dt = 0.004;
  
  useFrame(() => {
    
    if (animInAction && t < 0.3) {
      
      let ti = t += dt;
      orbit.current["object"].position.lerp(newPos, ti);
      orbit.current.target.lerp(newTarget, ti);
      
    } else {
      animInAction = false;
    }
    orbit.current.minDistance = 1.2;
    orbit.current.maxDistance = 3;
    orbit.current.maxPolarAngle = degToRad(90);
    
  });
  
  useEffect(() => {
    
    if (!camaraPositions) return;
    
    currCamPos = camaraPositions[Object.keys(camaraPositions)[currentCamPos]];
    
    newPos = new Vector3(
      currCamPos.pos.x,
      currCamPos.pos.y,
      currCamPos.pos.z
    )
    
    newTarget = new Vector3(
      currCamPos.target.x,
      currCamPos.target.y,
      currCamPos.target.z
    )
    
    animInAction = true;
    
  }, [currentCamPos]);
  
  // on init
  useEffect(() => {
  
    // default cam pos - done here
    animInAction = false;
    
    orbit.current["object"].position.x = defaultPos.x;
    orbit.current["object"].position.y = defaultPos.y;
    orbit.current["object"].position.z = defaultPos.z;

    orbit.current.target = new Vector3(defaultTarget.x, defaultTarget.y, defaultTarget.z)

    orbit.current.minDistance = 1.2;
    orbit.current.maxDistance = 3;
    orbit.current.minPolarAngle = 0;
  
    
    // const defaultPos = new Vector3(0, -2, 5);
    // const defaultTarget = new Vector3(0, 0, 0);
    
  }, []);
  
}

export default CamaraController;

